/**
 * Events Resource
 *
 * Thin 1:1 mapping to the events API. No business logic, no default
 * parameter injection. The SDK passes params as-is.
 */

import type { HttpLayer } from '../http.js';
import type {
  IngestEventsRequest,
  IngestEventsResponse,
  EventSummaryParams,
  EventCountsParams,
  TopEventsParams,
  ActiveUsersParams,
} from '../types/index.js';

export class EventsResource {
  constructor(private http: HttpLayer) {}

  async ingest(
    params: IngestEventsRequest,
  ): Promise<IngestEventsResponse> {
    return this.http.post('/v1/events', params);
  }

  async getSummary(
    params?: EventSummaryParams,
  ): Promise<Record<string, unknown>> {
    return this.http.get('/v1/events/summary', params);
  }

  async getCounts(
    params?: EventCountsParams,
  ): Promise<Record<string, unknown>> {
    return this.http.get('/v1/events/counts', params);
  }

  async getTopEvents(
    params?: TopEventsParams,
  ): Promise<Record<string, unknown>> {
    return this.http.get('/v1/events/top', params);
  }

  async getActiveUsers(
    params?: ActiveUsersParams,
  ): Promise<Record<string, unknown>> {
    return this.http.get('/v1/events/active-users', params);
  }
}
